<template>
  <div id="app">
    <div id="Return_Bar">
      <i class="el-icon-arrow-left"></i>
      <div @click="isreturn" class="isreturn">返回</div>
    </div>
    <div id="text">
      <div class="title">{{trainTitle}}</div>
      <div class="list" v-for="(item,index) in SessionsList" :key="index">
        <div class="list_title">{{item.trainIndexDesc}}</div>
        <div class="list_attribute">
          <div class="Training_date">培训日期：{{item.trainDate}}</div>
          <div class="Training_time">
            培训时间：<span v-for="(i,s) in item.trainTimeList" :key="s">{{i}}<span v-if="s < item.trainTime.length - 1">，</span></span>
          </div>
          <div class="Trainer">培训讲师：{{item.teacherName}}</div>
        </div>
        <div class="title_content">
          <div class="title_content_text">
            培训内容：{{trainContent}}
          </div>
        </div>
        <div class="list_button_stuta list_button_stuta1" v-if="item.signStatus=='Yes'">已签到</div>
        <div class="list_button_stuta list_button_stuta2" v-if="item.signStatus=='noSignAlreadyOpen'" @click="GoSignin(item.seqId)">点击签到</div>
        <div class="list_button_stuta" :class="item.signStatus=='noSignedNoOpen' && item.signStatus!='Yes'?'list_button_stuta4':'list_button_stuta3'" v-if=" item.signStatus=='noSignedNoOpen'">点击签到</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sessions",
  data() {
    return {
      trainId:this.$route.query.trainId,
      trainTitle:this.$route.query.trainTitle,//上个场景页面的title
      SessionsList:[],//场景列表
      trainContent:this.$route.query.trainContent//场景文本框内容
    };
  },
  created(){this.signUp()
  console.log(this.$route.query)},
  methods: {
    // 返回按钮
    isreturn() {
      this.$router.go(-1)
    },
    signUp(){
        {
      this.$http.post(API_ROOT.college + "/preWorkTrain/customer/signList",{trainId:this.trainId})
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
              this.SessionsList=result.data.signList
            console.log(this.SessionsList,77777)
            } else {
                this.$alert(result.msg);//因为需要查看课程列表所以屏蔽
            }
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
            );
          }
        );
    }
    },
    signUp(){
      this.$http.post(API_ROOT.college + "/preWorkTrain/customer/signList",{trainId:this.trainId})
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
              this.SessionsList=result.data.signList
            console.log(this.SessionsList,77777)
            } else {
                this.$alert(result.msg);//因为需要查看课程列表所以屏蔽
            }
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
            );
          }
        );
    },
    GoSignin(seqId){
        var self = this;
      this.$http.post(API_ROOT.college + "/preWorkOnlineTrain/sign?",{seqId:seqId})
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
                this.signUp();
              // this.SessionsList=result.data.signList
            // console.log(this.SessionsList,77777)
            } else {
                this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
            );
          }
        );
    }
  },
};
</script>
<style scoped>
#app {
  height: 100%;
  box-sizing: border-box;
  background: #f6f5f8;
}
#Return_Bar {
  padding-left: 21px;
  display: flex;
  padding-top: 10px;
  padding-bottom: 15px;
  width: 100%;
  background: #fff;
}
/deep/.el-icon-arrow-left {
  margin-top: 5px;
}
#text {
  background: #f6f5f8;
  width: 100%;

  padding: 20px 20px;
}
.isreturn {
  color: #262626;
  cursor: pointer;
  margin-top: 2px;
}
.title {
  margin-top: 21px;
  margin-bottom: 20px;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #262626;
  line-height: 24px;
}
.list {
  background: #ffffff;
  border-radius: 10px;
  margin-bottom: 20px;
  padding-bottom: 20px;
  position: relative;
}
.list_title {
  width: 100px;
  height: 34px;
  background: #497af2;
  border-radius: 10px 0px 10px 0px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  line-height: 34px;
}
.list_attribute {
  margin-left: 20px;
  margin-top: 20px;
}
.Training_date,
.Training_time,
.Trainer {
  margin-bottom: 8px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #262626;
}
.title_content {
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 4px;
  background: #f5f6f7;
  padding: 20px;
}
.title_content_text {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #262626;
}
.list_button_stuta{
  position: absolute;
  top: 46px;
  right: 20px;
  width: 100px;
  height: 28px;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  letter-spacing: 1px;
  text-align: center;
  line-height: 28px;
  cursor: pointer;}
.list_button_stuta1 {
  background: #dbe5ff;
  color: #497af2;
}
.list_button_stuta2{
background: #497AF2;
color: #FFFFFF;
}
.list_button_stuta3{
top: 85px;
background: #E1E1E1;
color: #ABABAB;

}
.list_button_stuta4{
background: #E1E1E1;
color: #ABABAB;
}
</style>



// WEBPACK FOOTER //
// ./src/page/train/newservice/Sessions.vue